'use client';

import { useEffect } from 'react';
import posthog from 'posthog-js';
import { usePathname, useSearchParams } from 'next/navigation';

const PH_KEY = process.env.NEXT_PUBLIC_POSTHOG_KEY ?? '';
const PH_HOST = process.env.NEXT_PUBLIC_POSTHOG_HOST || 'https://app.posthog.com';
const PH_ENABLED = process.env.NEXT_PUBLIC_POSTHOG_ENABLED !== 'false';

export function PostHogProvider({ children }: { children: React.ReactNode }) {
  // Init once on the client (safe across Fast Refresh)
  useEffect(() => {
    if (!PH_ENABLED || !PH_KEY) return;
    if (typeof window === 'undefined') return;

    // Use a window-scoped flag to avoid re-init during HMR / re-mounts
    const w = window as any;
    if (w.__PH_INITED__) return;

    posthog.init(PH_KEY, {
      api_host: PH_HOST,
      autocapture: true,          // clicks, submits, etc.
      capture_pageview: false,    // we'll manually track for Next.js routing
      persistence: 'localStorage+cookie',
      disable_session_recording: false,
      // respect_dnt: true,
      loaded: () => {
        w.__PH_INITED__ = true;
      },
    });
  }, []);

  // Track pageviews on route changes
  const pathname = usePathname();
  const searchParams = useSearchParams();
  useEffect(() => {
    if (!PH_ENABLED || !PH_KEY) return;
    posthog.capture('$pageview');
  }, [pathname, searchParams]);

  return <>{children}</>;
}
